var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSafebrowsingLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 133,
    height: 40,
    viewBox: "0 0 133 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_21",
    "data-name": "Caminho 21",
    d: "M605.988,191.2c-6.608,0-12.33,2.718-14.648,3.567v3.851c0,10.7.041,18.1,6.261,24.321a76.89,76.89,0,0,0,8.225,6.328,75.728,75.728,0,0,0,8.274-6.328c6.232-6.238,6.211-12.79,6.211-22.891v-5.328C617.411,193.825,612.211,191.2,605.988,191.2Z",
    transform: "translate(-591.34 -191.2)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: -0.157,
    x2: 0.5,
    y2: 0.669,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#263238",
    stopOpacity: 0.349
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#263238",
    stopOpacity: 0.149
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#263238",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#263238",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_24",
    "data-name": "Caminho 24",
    d: "M628.493,388.878a15.29,15.29,0,0,0,2.085,4.165,47.137,47.137,0,0,0,4.375,4.716,49.764,49.764,0,0,0,4.3-4.716,15.058,15.058,0,0,0,2.117-4.337C642.591,385.646,627.27,386.4,628.493,388.878Z",
    transform: "translate(-628.424 -386.701)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "safebrowsing-logo",
    transform: "translate(-129 -183)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7",
    "data-name": "Grupo 7",
    transform: "translate(129 183)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6",
    "data-name": "Grupo 6",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3",
    "data-name": "Grupo 3",
    transform: "translate(36.994 3.818)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2",
    "data-name": "Grupo 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Google_2015_logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_12",
    "data-name": "Caminho 12",
    d: "M79.873,29.3A4.312,4.312,0,1,1,75.562,25,4.247,4.247,0,0,1,79.873,29.3Zm-1.888,0a2.43,2.43,0,1,0-2.424,2.607A2.477,2.477,0,0,0,77.985,29.3Z",
    transform: "translate(-57.513 -20.241)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_13",
    "data-name": "Caminho 13",
    d: "M127.874,29.3a4.312,4.312,0,1,1-4.312-4.3A4.247,4.247,0,0,1,127.874,29.3Zm-1.888,0a2.431,2.431,0,1,0-2.424,2.607,2.477,2.477,0,0,0,2.424-2.607Z",
    transform: "translate(-96.213 -20.241)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14",
    "data-name": "Caminho 14",
    d: "M175.469,25.26v7.725c0,3.178-1.872,4.475-4.085,4.475a4.093,4.093,0,0,1-3.81-2.535l1.643-.685a2.374,2.374,0,0,0,2.164,1.527c1.417,0,2.294-.875,2.294-2.522v-.619h-.066a2.925,2.925,0,0,1-2.263.978,4.306,4.306,0,0,1,0-8.6,2.977,2.977,0,0,1,2.263.962h.066v-.7h1.792Zm-1.659,4.058a2.423,2.423,0,0,0-2.294-2.623,2.617,2.617,0,0,0,0,5.214,2.4,2.4,0,0,0,2.294-2.592Z",
    transform: "translate(-134.893 -20.241)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_15",
    "data-name": "Caminho 15",
    d: "M217.341,3V15.609H215.5V3Z",
    transform: "translate(-173.811 -2.509)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_16",
    "data-name": "Caminho 16",
    d: "M235.472,30.711l1.465.978a4.277,4.277,0,0,1-3.581,1.907,4.208,4.208,0,0,1-4.265-4.3,4.087,4.087,0,0,1,4.054-4.3,3.992,3.992,0,0,1,3.678,2.737l.2.489L231.273,30.6a2.187,2.187,0,0,0,2.083,1.3A2.453,2.453,0,0,0,235.472,30.711Zm-4.509-1.548,3.84-1.6a1.664,1.664,0,0,0-1.595-.912A2.359,2.359,0,0,0,230.963,29.163Z",
    transform: "translate(-184.768 -20.233)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_17",
    "data-name": "Caminho 17",
    d: "M7.129,8.412V6.586h6.145a6.055,6.055,0,0,1,.091,1.1,6.032,6.032,0,0,1-1.579,4.27,6.1,6.1,0,0,1-4.655,1.874A6.771,6.771,0,0,1,.36,7.151,6.771,6.771,0,0,1,7.131.47,6.356,6.356,0,0,1,11.7,2.311L10.417,3.6A4.645,4.645,0,0,0,7.129,2.3,4.79,4.79,0,0,0,2.342,7.151a4.79,4.79,0,0,0,4.786,4.856A4.463,4.463,0,0,0,10.5,10.67a3.785,3.785,0,0,0,.988-2.26Z",
    transform: "translate(-0.36 -0.47)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_18",
    "data-name": "Caminho 18",
    d: "M8.941-58.671A4.97,4.97,0,0,1,5.509-59.7a3.6,3.6,0,0,1-1.2-2.646H5.7a2.253,2.253,0,0,0,1.011,1.8,3.917,3.917,0,0,0,2.173.582,3.421,3.421,0,0,0,1.944-.5,1.547,1.547,0,0,0,.737-1.349,1.374,1.374,0,0,0-.763-1.3,11,11,0,0,0-2.625-.8,6.057,6.057,0,0,1-2.673-1.1,2.359,2.359,0,0,1-.81-1.875,2.651,2.651,0,0,1,1.055-2.164,4.352,4.352,0,0,1,2.8-.845,4.779,4.779,0,0,1,2.962.852A3.019,3.019,0,0,1,12.7-66.646H11.3q-.215-1.972-2.7-1.972a3.259,3.259,0,0,0-1.858.452,1.392,1.392,0,0,0-.659,1.2,1.136,1.136,0,0,0,.529,1.023,6.709,6.709,0,0,0,1.977.66,18.633,18.633,0,0,1,2.3.63,3.68,3.68,0,0,1,1.459.967,2.489,2.489,0,0,1,.607,1.76A2.9,2.9,0,0,1,11.847-59.6,4.4,4.4,0,0,1,8.941-58.671Zm10.81-2.253v-1.742H18.8q-3.036,0-3.036,1.653a1.071,1.071,0,0,0,.444.923,2,2,0,0,0,1.2.322,3.029,3.029,0,0,0,1.333-.311A2.559,2.559,0,0,0,19.75-60.924Zm0,1.26A3.869,3.869,0,0,1,17-58.671a2.893,2.893,0,0,1-1.925-.634,2.036,2.036,0,0,1-.755-1.634q0-2.757,4.746-2.757h.681a6,6,0,0,0-.089-1.227,1.018,1.018,0,0,0-.5-.634,2.547,2.547,0,0,0-1.3-.252q-1.866,0-1.925,1.334H14.553q.156-2.424,3.391-2.424a4.009,4.009,0,0,1,2.354.6,2.733,2.733,0,0,1,.844,2.357v5.085H19.75Zm5.094-5.959v6.767H23.452v-6.767H22.3v-1.1h1.155v-.7q0-2.49,2.2-2.49a4.718,4.718,0,0,1,1.044.089V-68.6a4.787,4.787,0,0,0-.844-.074.952.952,0,0,0-.759.285,1.52,1.52,0,0,0-.248.99v.682h1.488v1.1Zm5.916,6.953a3.7,3.7,0,0,1-2.784-1.086,4.171,4.171,0,0,1-1.052-3.028,4.26,4.26,0,0,1,1.018-3.02A3.469,3.469,0,0,1,30.6-66.9a3.5,3.5,0,0,1,2.684,1.075,4.286,4.286,0,0,1,1,3.039v.333H28.376a3.042,3.042,0,0,0,.752,2.024,2.224,2.224,0,0,0,1.633.66,2.411,2.411,0,0,0,1.322-.374,1.26,1.26,0,0,0,.618-1.064h1.444a2.608,2.608,0,0,1-1.1,1.875A3.865,3.865,0,0,1,30.761-58.671Zm2.058-4.877a2.851,2.851,0,0,0-.763-1.7,2.027,2.027,0,0,0-1.451-.563,2.032,2.032,0,0,0-1.437.56,2.787,2.787,0,0,0-.763,1.7Zm15.363,1.535a2.8,2.8,0,0,1-1.037,2.342,4.8,4.8,0,0,1-3.013.815H40.067V-69.722h3.865a4.462,4.462,0,0,1,2.725.741,2.4,2.4,0,0,1,.992,2.031,2.46,2.46,0,0,1-1.562,2.327,2.68,2.68,0,0,1,1.573.982A2.69,2.69,0,0,1,48.182-62.013ZM41.5-65.171h2.414a3.176,3.176,0,0,0,1.754-.382,1.424,1.424,0,0,0,.563-1.271,1.4,1.4,0,0,0-.548-1.2,3.325,3.325,0,0,0-1.9-.4H41.5Zm0,5.025h2.614q2.577,0,2.577-1.868a1.661,1.661,0,0,0-.6-1.419,3.783,3.783,0,0,0-2.166-.449H41.5Zm12.572-5.3a3.124,3.124,0,0,0-.851-.089A2.194,2.194,0,0,0,51.4-64.415v5.559H50V-66.72h1.4v1.1A2.494,2.494,0,0,1,53.439-66.9a3.723,3.723,0,0,1,.637.059ZM58.229-66.9a3.5,3.5,0,0,1,2.684,1.075,4.286,4.286,0,0,1,1,3.039,4.289,4.289,0,0,1-1,3.035,3.49,3.49,0,0,1-2.684,1.079,3.481,3.481,0,0,1-2.677-1.079,4.289,4.289,0,0,1-1-3.035,4.285,4.285,0,0,1,1-3.039A3.488,3.488,0,0,1,58.229-66.9Zm0,7.13a2,2,0,0,0,1.621-.76,3.5,3.5,0,0,0,.622-2.257,3.514,3.514,0,0,0-.622-2.264,2,2,0,0,0-1.621-.76,2,2,0,0,0-1.621.76,3.514,3.514,0,0,0-.622,2.264,3.5,3.5,0,0,0,.622,2.257,2,2,0,0,0,1.622.76ZM73.319-66.72l-2.362,7.864H69.624l-1.7-5.781-1.7,5.781H64.893L62.524-66.72h1.547l1.444,6,1.77-6h1.274l1.777,6,1.444-6Zm3.917,8.05q-3.221,0-3.369-2.535h1.4q.015,1.438,1.955,1.438a2.1,2.1,0,0,0,1.322-.359,1.1,1.1,0,0,0,.455-.9.771.771,0,0,0-.444-.752,11.166,11.166,0,0,0-1.833-.567,6.745,6.745,0,0,1-2.029-.778,1.687,1.687,0,0,1-.64-1.512,1.994,1.994,0,0,1,.8-1.62,3.294,3.294,0,0,1,2.129-.641q3.087,0,3.154,2.2H78.739q-.074-1.112-1.666-1.112a2.308,2.308,0,0,0-1.166.267.85.85,0,0,0-.463.778.706.706,0,0,0,.355.663,8.877,8.877,0,0,0,1.781.549,6.881,6.881,0,0,1,2.118.8,1.761,1.761,0,0,1,.692,1.586,2.218,2.218,0,0,1-.855,1.783,3.494,3.494,0,0,1-2.3.708Zm6.175-.185h-1.4V-66.72h1.4Zm0-9.354h-1.4v-1.512h1.4Zm3.458,2.49A3.087,3.087,0,0,1,89.215-66.9q2.658,0,2.658,2.9v5.144h-1.4v-5.085a2.2,2.2,0,0,0-.344-1.386A1.378,1.378,0,0,0,89-65.749a2.92,2.92,0,0,0-2.132,1.26v5.633h-1.4V-66.72h1.4Zm13.4,6.256q0,3.795-3.421,3.795a3.8,3.8,0,0,1-2.336-.645,2.061,2.061,0,0,1-.855-1.734H95.1q0,1.29,1.733,1.29a2.034,2.034,0,0,0,1.51-.537,3.051,3.051,0,0,0,.533-2.109V-59.8a2.824,2.824,0,0,1-2.243,1.126,2.832,2.832,0,0,1-2.384-1.1,4.736,4.736,0,0,1-.845-2.957,4.591,4.591,0,0,1,.944-3.05A2.971,2.971,0,0,1,96.723-66.9a3.122,3.122,0,0,1,2.155.786v-.608h1.392Zm-1.392-1.653v-3.736a2.772,2.772,0,0,0-2.066-.956,1.662,1.662,0,0,0-1.433.775,4.067,4.067,0,0,0-.537,2.309,3.952,3.952,0,0,0,.507,2.2,1.6,1.6,0,0,0,1.4.752,2.657,2.657,0,0,0,2.125-1.349Z",
    transform: "translate(-4.264 88.109)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "safebrowsing-logo-2",
    "data-name": "safebrowsing-logo",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_19",
    "data-name": "Caminho 19",
    d: "M591.33,225.022v3.851c0,3.522,0,6.685.229,9.595.456,5.848,1.838,10.55,6.011,14.726a76.44,76.44,0,0,0,8.245,6.328v-34.5C599.732,225.022,593.648,224.173,591.33,225.022Z",
    transform: "translate(-591.33 -219.523)",
    fill: "#66bb6a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_20",
    "data-name": "Caminho 20",
    d: "M655.815,227.974c-14.431-.027-8.4,0-14.485,0v34.548a75.723,75.723,0,0,0,8.274-6.328c6.232-6.238,6.211-12.79,6.211-22.891Z",
    transform: "translate(-626.845 -222.524)",
    fill: "#388e3c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4",
    "data-name": "Grupo 4",
    transform: "translate(0.003 1.929)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1",
    "data-name": "Ret\\xE2ngulo 1",
    width: 31.346,
    height: 2.581,
    transform: "translate(-1.118 3.564)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5",
    "data-name": "Grupo 5",
    transform: "translate(7.976 23.32)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_26",
    "data-name": "Caminho 26",
    d: "M4.711,0A4.713,4.713,0,0,1,9.421,4.716c0,2.6-9.421,2.6-9.421,0A4.713,4.713,0,0,1,4.711,0Z",
    transform: "translate(1.929 6.968)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22",
    "data-name": "Caminho 22",
    d: "M613.89,285.718a8.079,8.079,0,0,1,13.266-6.2C628.915,280.98,613.89,290.185,613.89,285.718Zm8.08-6.505a6.5,6.5,0,0,0-6.5,6.505c0,3.593,13,3.593,13,0A6.51,6.51,0,0,0,621.97,279.212Z",
    transform: "translate(-615.33 -273.953)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_23",
    "data-name": "Caminho 23",
    d: "M601.95,277.242a11.539,11.539,0,1,1,23.078,0C625.022,283.619,601.95,283.621,601.95,277.242Zm11.539-9.89a9.884,9.884,0,0,0-9.879,9.89c0,5.462,19.758,5.462,19.758,0a9.9,9.9,0,0,0-9.879-9.887Z",
    transform: "translate(-606.849 -265.477)",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_25",
    "data-name": "Caminho 25",
    d: "M620.308,189.4v-2.958a3.149,3.149,0,0,0-2.781-2.552H593.878a2.884,2.884,0,0,0-2.538,2.552V189.4h28.971Z",
    transform: "translate(-591.337 -183.89)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_6",
    "data-name": "Elipse 6",
    cx: 0.852,
    cy: 0.853,
    rx: 0.852,
    ry: 0.853,
    transform: "translate(2.723 2.057)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_7",
    "data-name": "Elipse 7",
    cx: 0.852,
    cy: 0.853,
    rx: 0.852,
    ry: 0.853,
    transform: "translate(5.84 2.057)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_8",
    "data-name": "Elipse 8",
    cx: 4.774,
    cy: 4.78,
    rx: 4.774,
    ry: 4.78,
    transform: "translate(138.615 194.233)",
    fill: "#fafafa"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafebrowsingLogo);
export default __webpack_public_path__ + "static/media/safebrowsing-logo.baac418d68a3dfc6c6a9d2e164bdd551.svg";
export { ForwardRef as ReactComponent };